import { render, staticRenderFns } from "./FormRegister.vue?vue&type=template&id=122281d5&scoped=true&"
import script from "./FormRegister.vue?vue&type=script&lang=js&"
export * from "./FormRegister.vue?vue&type=script&lang=js&"
import style0 from "./FormRegister.vue?vue&type=style&index=0&id=122281d5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122281d5",
  null
  
)

export default component.exports